import React, { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { QRCodeSVG } from "qrcode.react";
import { Copy, Check } from "lucide-react";
import logo from "../assets/images/logo.svg";
import { useToast } from "../hooks/use-toast";
import { getSecret } from "../services/digitalWalletService";
import DownloadAuthAppButton from "./DownloadAuthAppButton";
const TwoFAQrCode = ({ onNext, onCancel, existingSecret = null }) => {
  const [secret, setSecret] = useState(() => {
    if (existingSecret) {
      return {
        base32: existingSecret,
        otpauth_url: `otpauth://totp/80Eight?secret=${existingSecret}`,
      };
    }
    return [];
  });
  const [copied, setCopied] = useState(false);
  const { toast } = useToast();
  useEffect(() => {
    if (existingSecret) {
      setSecret({
        base32: existingSecret,
        otpauth_url: `otpauth://totp/80Eight?secret=${existingSecret}`,
      });
      return;
    }
    const pullSecret = async () => {
      const secret = await getSecret();
      const actualSecret = secret.data.data;
      setSecret(actualSecret);
    };
    pullSecret();
  }, [existingSecret]);

  const handleCopy = () => {
    navigator.clipboard.writeText(secret?.base32);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    toast({
      description: "Wallet Address Copied Successfully",
      variant: "eighty",
    });
  };
  return (
    <Card className="bg-white rounded-2xl shadow-sm overflow-hidden">
      <CardContent className="pt-10 pb-8 px-10">
        <div className="flex flex-col justify-center">
          <h3 className="text-[32px] font-semibold text-left text-[#57249C] mb-2">
            Enable 2-Factor Authentication
          </h3>
          <p className="text-[#423E51] text-[20px]">
            Download either the Google or Microsoft Authenticator app and add a
            new account, and then scan this QR code.
          </p>
        </div>
        <div className="flex justify-center mt-8 mb-8">
          <div className="border border-[1px] border-[#EBE9EF] rounded-lg w-[250px] h-[250px] p-[12px] flex items-center justify-center">
            <QRCodeSVG
              value={secret?.otpauth_url}
              size={200}
              imageSettings={{
                src: logo,
                height: 40,
                width: 40,
                excavate: true,
              }}
            />
          </div>
        </div>
        <div className="mb-10 rounded-2xl border border-[#F1EDF7] bg-[#FBFAFD] p-4 md:p-5 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div>
            <p className="text-sm uppercase tracking-wide text-[#9D96AF]">
              Need an authenticator app?
            </p>
            <p className="text-base font-semibold text-[#423E51]">
              Download it in one tap.
            </p>
          </div>
          <DownloadAuthAppButton className="w-full md:w-auto px-6 py-3" />
        </div>
        <div className="mb-5">
          <p className="text-[#423E51] text-[20px]">
            Or enter this secret key into your authenticator app:
          </p>
        </div>
        <div className="space-y-2 mb-10">
          <div className="flex justify-between items-center gap-4 h-[88px] bg-[#EBE9EF4D] rounded-2xl p-4 text-gray-500">
            <span className="flex-1 break-all">{secret?.base32}</span>
            <Button
              variant="outline"
              className="rounded-full border-gray-500 bg-gray-100 w-10 h-10"
              onClick={handleCopy}
            >
              {copied ? (
                <Check className="h-5 w-5 text-green-500" />
              ) : (
                <Copy className="h-5 w-5 text-gray-500" />
              )}
            </Button>
          </div>
        </div>
        <div className="flex items-center justify-center gap-3 ">
          <Button
            onClick={() => {
              if (onCancel) {
                onCancel();
              }
            }}
            variant="outline"
            className="rounded-full py-6 px-24 w-[48%] text-[#6D6584] font-semibold bg-white hover:opacity-90"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (onNext) {
                onNext(secret?.base32);
              }
            }}
            variant="outline"
            className="bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] text-white px-6 py-4 rounded-full font-semibold hover:opacity-90 transition-opacity w-[48%] h-[48px]"
          >
            Next
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default TwoFAQrCode;
